// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".lumen5-popover--FRemI{background-color:#fff;box-shadow:0 2px 4px rgba(40,28,90,.05),0 8px 24px rgba(40,28,90,.1);border-radius:.375rem;z-index:9999}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"lumen5-popover": "lumen5-popover--FRemI"
};
export default ___CSS_LOADER_EXPORT___;
